export default "__VITE_ASSET__49119f57__"